import type { ResourceBlock } from '@root/@types/base';

import type { CallbackState } from './types';

export const initialCallbackState: CallbackState = { fn: undefined };

type BlockKey = keyof ResourceBlock;

export const AS_NEW_BLOCK_PAYLOAD_KEYS: BlockKey[] = [
  'canDelete',
  'canEdit',
  'canEditOnTemplate',
  'class_of_business',
  'classification',
  'clause_reference',
  'clause_type',
  'content',
  'expiry_date',
  'helperText',
  'inception_date',
  'linkedDatapoints',
  'repeaterIds',
  'shouldInsertPageBreak',
  'teams',
  'title',
  'type',
  'variations',
];

export const CREATE_LIBRARY_BLOCK_PAYLOAD_KEYS: BlockKey[] = [
  'canDelete',
  'canEdit',
  'canEditOnTemplate',
  'class_of_business',
  'clause_reference',
  'clause_type',
  'content',
  'expiry_date',
  'helperText',
  'inception_date',
  'linkedDatapoints',
  'name',
  'repeaterIds',
  'shouldInsertPageBreak',
  'teams',
  'title',
  'type',
  'variations',
];

export const CREATE_RESOURCE_BLOCK_PAYLOAD_KEYS: BlockKey[] = [
  ...CREATE_LIBRARY_BLOCK_PAYLOAD_KEYS,
  'blockLibraryId',
  'canDeleteOnTemplate',
  'section_id',
  'visibility',
];

export const UPDATE_TEMPLATE_BLOCK_PERMISSIONS_KEYS: BlockKey[] = ['canDelete', 'canDeleteOnTemplate', 'canEdit'];
export const UPDATE_LIBRARY_BLOCK_PERMISSIONS_KEYS: BlockKey[] = ['canDelete', 'canEdit', 'canEditOnTemplate'];

export const UPDATE_LIBRARY_BLOCK_PAYLOAD_KEYS: BlockKey[] = [
  ...UPDATE_LIBRARY_BLOCK_PERMISSIONS_KEYS,
  'class_of_business',
  'classification',
  'clause_reference',
  'clause_type',
  'content',
  'helperText',
  'linkedDatapoints',
  'name',
  'repeaterIds',
  'shouldInsertPageBreak',
  'teams',
  'title',
  'type',
  'variations',
  'inception_date',
  'expiry_date',
  'last_imported_at',
];

export const UPDATE_RESOURCE_BLOCK_PAYLOAD_KEYS: BlockKey[] = [
  ...UPDATE_LIBRARY_BLOCK_PAYLOAD_KEYS,
  'canDeleteOnTemplate',
  'section_id',
  'selectedVariationId',
  'visibility',
];
